import { store } from "../store";
import { logoutUser } from "../actions/authActions";

export default function checkForExpiredToken(decodedToken) {
  if (!decodedToken || !decodedToken.exp) {
    return;
  }

  // Check for expired token
  const currentTime = Date.now() / 1000;

  if (decodedToken.exp < currentTime) {
    // Logout user
    store.dispatch(logoutUser());
    // Redirect to login
    window.location.href = "/login";
  }
}
